import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["state", "stepOne", "otp", "mfa", "submit"];

  connect() {
    console.log("SessionsController connected");
    this.updateFromState();

    this.observer = new MutationObserver(() => this.updateFromState());
    this.observer.observe(this.stateTarget, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  disconnect() {
    this.observer?.disconnect();
  }

  updateFromState() {
    const mode = (this.stateTarget.textContent || "").trim();
    const isLogin = mode === "login";
    const isOtp = mode === "otp";
    const isMfa = mode === "mfa";

    this.stepOneTarget.classList.toggle("hidden", !isLogin);
    this.otpTarget.classList.toggle("hidden", !isOtp);
    this.mfaTarget.classList.toggle("hidden", !isMfa);

    this.enable();
  }

  disable() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = true;
  }
  enable() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = false;
  }

  maybeEnable(event) {
    const success = !!event?.detail?.success;
    if (!success) this.enable();
  }
}
